var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"rating"},[_vm._l((_vm.btns),function(btn){return _c('li',{class:btn.status,on:{"click":function($event){_vm.setRating(btn.score)}}})}),_vm._v(" "),(_vm.userSet)?_c('span',[_vm._v(_vm._s(_vm.userSet)+"分")]):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46cafc40","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/globalComp/ratingSet.vue
// module id = null
// module chunks = 